import VideoService from './VideoService';
import { Amplify, Auth, Storage } from 'aws-amplify';
import CmsAPI from '../../common/apis/CmsAPI';

let durationInterval;
let seconds = 0;

const reset = () => {
  clearInterval(durationInterval);
  durationInterval = undefined;
  seconds = 0;
};

const msToHourMinSecMs = inputMs => {
  // Split milliseconds input into its time components
  let ms = inputMs % 1000;
  let s = (inputMs / 1000) % 60;
  let m = (inputMs / (1000 * 60)) % 60;
  let h = (inputMs / (1000 * 60 * 60)) % 24;

  function pad(num, size = 2) {
    num = parseInt(num);
    num = num.toString();
    while (num.length < size) num = '0' + num;
    return num;
  }

  // Pad with leading zeros
  ms = pad(ms).substring(0, 2);
  s = pad(s);
  m = pad(m);
  h = pad(h);

  return `${h}:${m}:${s}:${ms}`;
};

export async function uploadVideoDirectly(message) {
  console.log('Upload video directly');

  reset();

  const { isUrl = false, videoBlob, videoName, folderId, videoExtension, videoDuration, onUploadProgress, videoIndex } = message;

  // Get the video file data from the blob url

  console.log('videoFile fetch');

  let videoFile = videoBlob;

  if (isUrl) {
    videoFile = await fetch(videoBlob).then(res => res.arrayBuffer());
  }

  console.log('Before upload video to AWS');
  const videoKey = await VideoService.uploadVideoToAws({ video: videoFile, onUploadProgress, videoExtension, videoIndex });
  const videoParts = videoKey.split('/');
  const storyId = videoParts[0];
  const sceneId = videoParts[1].split('.')[0];

  console.log('Before StoryService');
  // Call POST /story/{storyId}/render endpoint here to start the render process
  const response = await CmsAPI.createStory(storyId, sceneId, folderId, videoName, videoKey, videoDuration);

  console.log('response', response);

  // Hardcode story object for now, as we might receive this later from the render endpoint
  let fullPath = await Storage.get(videoKey, { level: 'protected' });
  let story = {
    scenes: [
      {
        id: null,
        path: null,
        trimStart: '00:00:00:00',
        trimEnd: '00:00:00:00',
        subtitlesPath: null,
        subtitlesVisible: false,
        script: '',
        textPanel: null,
        name: 'Scene 1',
      },
    ],
    storyId: null,
    storyName: null,
    description: null,
    source: 'web',
    orientation: null,
    logo: null,
    intro: null,
    outro: null,
    active: 1,
    createDate: null,
    video: {
      thumbnail: null,
      path: null,
      duration: null,
      streamingPath: null,
      sharingLink: null,
      sharingShortLink: null,
    },
  };
  story.scenes[0].id = sceneId;
  story.scenes[0].path = fullPath;
  story.scenes[0].trimEnd = msToHourMinSecMs(videoDuration);
  story.storyId = storyId;
  story.storyName = videoName;
  story.video.duration = videoDuration;

  const userDetailsRaw = localStorage.getItem('userDetails');
  const userDetails = JSON.parse(userDetailsRaw);

  // Prep story object for insertion
  let cleanPath = story.scenes[0].path.split('?')[0].split('https://')[1];
  story.createDate = new Date()
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ');
  story.scenes[0].path = cleanPath;
  story.username = userDetails.username;
  story.video.path = cleanPath;

  story.scenes[0].path = fullPath;

  return story;
}
